export enum Direction {
  Above = 'above',
  Current = 'current',
  Below = 'below',
}

export type WithActiveState = { isActive: boolean };
export type WithDirection = { direction: Direction };
